<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    布心站<br>
站点介绍<br>
布心站位于罗湖区东晓路和东湖路交叉口南侧，沿东晓路布置。车站周围有华润万家、彩世界家园、布心广场等大型购物中心。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:21	23:10	5号线	3分钟	5分25秒<br>
黄贝岭	06:17	00:11	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:27	23:10	5号线	4分钟	6分钟<br>
黄贝岭	06:19	00:11	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:27	00:10	5号线	4分钟	6分钟<br>
黄贝岭	06:19	01:11	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
东湖路北侧、今日家园、阳光名居、一致春晓苑、翠园中学东晓校区<br><br>
B出入口:<br>
东晓路西侧（南）、东晓小学、罗湖区妇幼保健院、东湖派出所、布心市场、粤海城、太白居西门、海鹰大厦<br><br>
D出入口:<br>
东湖路南侧、罗湖区东晓社区健康服务中心、东湖街道办、布心中学、太白居北门、景亿山庄、心怡花园<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 翠园中学东晓校区<br>
29、M559、64、83、107、M172、M329、N2、N3<br><br>
D出入口:<br>
公交站名： 东湖路<br>
29、M559、83、107、M172、M329、M140、N2、N3<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


